// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-tips[data-v-6473262c] {\n  font-size: 12px;\n  color: #333;\n}\n.title-tips span[data-v-6473262c] {\n  color: #999;\n}\n.iconfont-diy[data-v-6473262c],\n.iconfont[data-v-6473262c] {\n  font-size: 20px;\n  line-height: 18px;\n}", ""]);
// Exports
module.exports = exports;
